// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#details-table table thead tr th,#summary-table table tbody tr:last-child,#summary-table table thead tr th{font-weight:700!important}", ""]);
// Exports
module.exports = exports;
